var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCardSupport(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 534,
    height: 499,
    viewBox: "0 0 534 499",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "a",
    d: "M3.87 9.71L.8.31l43.68 5.6L3.87 9.7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "c",
    d: "M35.49.9L.26 12l5.25 13.55L35.5.9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.23 44.14c-7.2 31.26 66.52 35.28 96.9 35.62 8.42.09 16.8-.7 25.05-2.38 25.69-5.21 81.91-18.9 74.03-37.5-10.18-23.99-40.74-7.26-40.74-7.26s3.84-18.11-48.17-30.08c-52-11.97-51.8 27.9-51.8 27.9S10.26 4.88 1.23 44.15",
    id: "e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.28 83.42H259.1s14.03-17.75 0-29.7c-7.75-6.6-16.9-5.91-23.54-3.97-4.33 1.26-8.65-1.66-9.6-6.07-1.57-7.3-6.42-16.85-20.35-22.5-13.71-5.55-22.38 2.93-27.4 11.64-1.65 2.87-6.04 2.44-7.04-.72C166.84 18.35 151.7.11 101.94.11c-63.28 0-56.25 33.65-50.6 47.63a3.22 3.22 0 01-3.65 4.4c-9.76-2.1-27.88-4.8-36 1.58C.28 62.68.28 83.42.28 83.42",
    id: "h"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.01.09s-7.54 17.57-9.45 17.57c-1.53 0 .58-14.35.58-14.35H4.83S-3.11 27.9 3.2 32.39c6.31 4.5 20.17-12.71 20.17-12.71L20.01.08",
    id: "k"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.37.46S.44 3.13.44 6.19v40.6H23.5V8.84S23.02.38 14.77.38 4.37.46 4.37.46",
    id: "n"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.04.93S21.08 15.4 21.08 24.09 10.5 48.06 10.5 48.06l-5.23-1.53S9.99 27.6 9.99 22.57c0-5.04-9.7-12.42-9.7-12.42",
    id: "q"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0%",
    y1: "50%",
    x2: "100%",
    y2: "50%",
    id: "f"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D4EBDE",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B0DCDF",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0%",
    y1: "50%",
    x2: "100%",
    y2: "50%",
    id: "i"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D4EBDE",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B0DCDF",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0%",
    y1: "50%",
    x2: "100%",
    y2: "50%",
    id: "l"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D4EBDE",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B0DCDF",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0%",
    y1: "50%",
    x2: "100%",
    y2: "50%",
    id: "o"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D4EBDE",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B0DCDF",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0%",
    y1: "50%",
    x2: "100%",
    y2: "50%",
    id: "r"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B0DCDF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D4EBDE",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#A0D2BB",
    d: "M314.87 12.71l-4.9 9.64 10.3-2.35 35.22-11.1-40.62 3.81"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5BBDB7",
    d: "M309.97 22.35l17.49-1.08-4.29-2.18-13.2 3.26"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(311 3)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a"
  })), /*#__PURE__*/React.createElement("path", {
    mask: "url(#b)",
    d: "M3.87 9.71L.8.31l43.68 5.6L3.87 9.7"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(320 8)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "d",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#c"
  })), /*#__PURE__*/React.createElement("path", {
    mask: "url(#d)",
    d: "M35.49.9L.26 12l5.25 13.55L35.5.9"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M313.83 32.06a.82.82 0 01-.17-1.35 23.15 23.15 0 013.46-2.5c.4-.23.9-.1 1.13.3.23.38.1.89-.3 1.12-1.12.66-2.2 1.44-3.2 2.32a.82.82 0 01-.92.1M334.69 53.8a.82.82 0 01.03-1.48 13.29 13.29 0 018.67-.81c.44.11.7.56.6 1a.82.82 0 01-1 .6 11.78 11.78 0 00-7.58.7c-.24.12-.5.1-.72 0zm14.3 9.35a.82.82 0 01-.43-.93c.5-1.97.32-3.79-.53-5.4a6.68 6.68 0 00-1.13-1.55.82.82 0 011.18-1.15 8.31 8.31 0 011.4 1.93 9.13 9.13 0 01.68 6.57.82.82 0 01-1.17.53zm-42.42-20.12a.82.82 0 01-.4-1 28.13 28.13 0 013.98-7.55.82.82 0 111.32.99 25.27 25.27 0 00-3.74 7.1.82.82 0 01-1.16.46zm18.78 20l-.07-.05a.82.82 0 01-.25-1.14 32.14 32.14 0 015.37-6.6.82.82 0 011.1 1.22 30.54 30.54 0 00-5.08 6.28.82.82 0 01-1.07.28zm15.2 9.9a.82.82 0 010-1.47 15.94 15.94 0 006-5.06.82.82 0 011.34.97 17.58 17.58 0 01-6.59 5.56.82.82 0 01-.75 0zm-35.08-16.79a.82.82 0 01-.44-.59 26.6 26.6 0 01-.08-8.54.82.82 0 111.63.24c-.4 2.72-.38 5.42.08 8.02a.82.82 0 01-1.19.87zm22.18 19.18a.82.82 0 01.44-1.55c2.75.23 5.43.03 7.98-.62a.82.82 0 11.4 1.6c-2.73.69-5.6.9-8.52.66a.82.82 0 01-.3-.09zm-16.26-7.5a.78.78 0 01-.22-.15 22.56 22.56 0 01-4.71-7.17.82.82 0 111.52-.62 21.06 21.06 0 004.37 6.64.82.82 0 01-.97 1.3zm7.43 6.78a.82.82 0 01-.37-1.1l.27-.53a26.89 26.89 0 01-3.59-2.02.82.82 0 11.92-1.36c1.07.72 2.23 1.36 3.42 1.9.88-1.69 1.86-3.45 2.96-5.35a.82.82 0 011.42.83c-1.06 1.83-2 3.53-2.86 5.17.77.3 1.56.55 2.35.77.45.13.7.58.57 1.01a.82.82 0 01-1.01.58c-.9-.25-1.8-.55-2.66-.89l-.3.62a.82.82 0 01-1.12.37zM314.04 87a.82.82 0 01-.42-.95 61.6 61.6 0 012.74-7.96.82.82 0 011.52.63 59.87 59.87 0 00-2.67 7.75.82.82 0 01-1.17.52zm-1.4 13.15a.82.82 0 01-.46-.67l-.02-.4c-.14-2.61 0-5.33.42-8.07a.82.82 0 111.63.25c-.4 2.63-.54 5.23-.4 7.73l.02.37a.82.82 0 01-1.2.8zm3.83 12.62a.8.8 0 01-.34-.33 31.05 31.05 0 01-3.15-7.9.82.82 0 111.6-.4 29.51 29.51 0 002.98 7.5.82.82 0 01-1.09 1.13zm9.08 9.52a24.79 24.79 0 01-6.51-5.62.82.82 0 011.26-1.05 23.16 23.16 0 006.04 5.23.82.82 0 01-.8 1.44zM330.19 124.3a.83.83 0 01.6-1.52c1.26.36 2.56.58 3.87.65a.82.82 0 11-.1 1.64 19.26 19.26 0 01-4.37-.76",
    fill: "#5BBDB7"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(193 206)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "g",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#e"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1.23 44.14c-7.2 31.26 66.52 35.28 96.9 35.62 8.42.09 16.8-.7 25.05-2.38 25.69-5.21 81.91-18.9 74.03-37.5-10.18-23.99-40.74-7.26-40.74-7.26s3.84-18.11-48.17-30.08c-52-11.97-51.8 27.9-51.8 27.9S10.26 4.88 1.23 44.15",
    fill: "url(#f)",
    mask: "url(#g)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(27)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "j",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#h"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M.28 83.42H259.1s14.03-17.75 0-29.7c-7.75-6.6-16.9-5.91-23.54-3.97-4.33 1.26-8.65-1.66-9.6-6.07-1.57-7.3-6.42-16.85-20.35-22.5-13.71-5.55-22.38 2.93-27.4 11.64-1.65 2.87-6.04 2.44-7.04-.72C166.84 18.35 151.7.11 101.94.11c-63.28 0-56.25 33.65-50.6 47.63a3.22 3.22 0 01-3.65 4.4c-9.76-2.1-27.88-4.8-36 1.58C.28 62.68.28 83.42.28 83.42",
    fill: "url(#i)",
    mask: "url(#j)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M117.46 208.7s-29.97-78.34-88.5-86.01c-42.4 56.92 13.88 113.87 13.88 113.87l67.65 28.36 6.97-56.22",
    fill: "#21837F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.25 156.12L68.4 189.28 30.34 122.9c-.46-.07-.91-.15-1.38-.21l-.48.67 20.38 35.55L15 152l-.2.96-.18.85 35.46 7.24 33.96 59.24-59.8-10.23 1.09 2.06 59.9 10.25 24.12 42.07 1.14.48.22-1.8-41.22-71.93 17.07-33.56-1.3-1.5",
    fill: "#005C5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.43 243.48S39.17 204.65.7 231.68c5.56 95.87 127.88 95.57 127.88 95.57l-31.15-83.77",
    fill: "#FACB57"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.7 231.7l.07 1.09 82.72 46.36-47.82 19.42 1.73 1.3 48.15-19.56 32.3 18.1-.99-2.68-62.9-35.25-10.84-37.71c-.65-.09-1.32-.16-1.98-.23l10.53 36.66L1.56 231.1l-.86.58",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.9 384.73a29.6 29.6 0 1128.66-51.8 29.6 29.6 0 01-28.66 51.8zm90.46.19c-.27-1.75-5.36-6.22-11.92-10a65.8 65.8 0 001.91-19.13c6.43-1.58 13.04-3.91 14.14-7 2.23-6.26-4.8-22.92-7.07-24.59-1.46-1.07-8.44-.59-15.9 1.47a65.74 65.74 0 00-11.8-14.94c3.43-5.68 6.48-12.03 5.07-15-2.86-6-19.6-12.81-22.4-12.38-1.74.26-6.18 5.33-9.96 11.85a65.74 65.74 0 00-19.33-2.54c-1.58-6.2-3.86-12.38-6.83-13.44-6.27-2.23-22.93 4.8-24.6 7.07-.98 1.35-.64 7.49 1.06 14.34a65.8 65.8 0 00-16.24 12.35c-5.19-2.99-10.6-5.33-13.28-4.06-6 2.85-12.81 19.6-12.39 22.39.24 1.57 4.36 5.32 9.93 8.8a65.79 65.79 0 00-2.67 21.05c-5.45 1.54-10.44 3.63-11.38 6.28-2.23 6.26 4.8 22.92 7.07 24.59 1.25.92 6.6.69 12.8-.7A65.77 65.77 0 0068 408.05c-2.76 4.93-4.8 9.92-3.6 12.44 2.86 6.01 19.61 12.82 22.4 12.4 1.57-.25 5.34-4.39 8.83-9.98a65.81 65.81 0 0020.81 1.96c1.56 5.74 3.72 11.16 6.49 12.14 6.26 2.23 22.92-4.8 24.59-7.07 1-1.36.64-7.55-1.09-14.45a65.74 65.74 0 0015.36-12.78c5.46 3.24 11.37 5.94 14.2 4.6 6-2.85 12.8-19.6 12.38-22.39z",
    fill: "#5BBDB7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.86 322.04a41.57 41.57 0 00-56.44 16.23 41.57 41.57 0 0016.23 56.43 41.57 41.57 0 0056.44-16.22 41.57 41.57 0 00-16.23-56.44zm-40.5 73.19a42.17 42.17 0 01-16.46-57.25 42.17 42.17 0 0157.25-16.46 42.17 42.17 0 0116.46 57.24 42.17 42.17 0 01-57.25 16.47z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.96 376.65l-.68-.5a60.4 60.4 0 01-5.07 12.14 60.45 60.45 0 01-82.07 23.6 60.4 60.4 0 01-31.08-50.31c-.27-.08-.54-.17-.8-.27a61.2 61.2 0 0031.5 51.27 61.24 61.24 0 0088.2-35.93M103.18 299.42a60.06 60.06 0 0138.43 6.8l.7.41.15-.81c-.16-.1-.3-.2-.47-.28a60.86 60.86 0 00-38.77-6.92c0 .26-.02.53-.04.8",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.76 167.07s-29.22-91.35 24.79-136.3c105.62 58.84 47.47 162.57 47.47 162.57l-72.26-26.27",
    fill: "#5BBDB7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.55 30.77l1.09.62 6.45 112.83 50.4-49.27c.26.74.5 1.49.73 2.23L397.25 147l1.87 32.56-2.16-.78-3.71-64.9-35.21-20.72.3-2.26 34.77 20.45-4.57-79.71 1-.87",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.74 146.16s34.17-89.33 100.9-98.08c48.37 64.9-15.82 129.84-15.82 129.84l-77.13 32.34-7.95-64.1",
    fill: "#FACB57"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M426.46 86.2L445.7 124l43.38-75.68 1.57-.24.56.77-23.24 40.54 38.6-7.89.24 1.1.2.96-40.44 8.26-38.72 67.56 68.2-11.68c-.41.8-.83 1.58-1.25 2.35l-68.3 11.7-27.5 47.97-1.3.54-.26-2.06 47-82-19.46-38.28 1.5-1.72",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.58 185.81s66.43-44.27 110.3-13.44c-6.34 109.3-145.82 108.96-145.82 108.96l35.52-95.51",
    fill: "#13374D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M522.87 172.37l-.08 1.25-94.32 52.86L483 248.63l-1.98 1.47-54.9-22.3-36.84 20.65 1.14-3.05 71.72-40.2 12.36-43c.75-.1 1.5-.19 2.26-.26l-12 41.8 57.13-32.03c.33.22.66.43.98.66",
    fill: "#005C5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.55 441.47c-.03-1.3 0-2.66.06-4.04l1 .05a53.53 53.53 0 00-.06 3.96l-1 .03M362.85 462.42c2.4.82 5.02 1.54 7.76 2.14l.22-.97c-2.71-.6-5.29-1.3-7.65-2.11l-.33.94M325.7 477.25l.16.98a53.81 53.81 0 007.83-1.92l-.32-.95c-2.39.79-4.9 1.4-7.68 1.88M262.46 473.32a56.72 56.72 0 007.58 2.72l.27-.96a56.18 56.18 0 01-7.45-2.68l-.4.92M337.17 426.06a25.86 25.86 0 00-.15 8.12l.99-.14a23.98 23.98 0 01.15-7.8l-.99-.18M299.9 478.55c-2.07 0-4.09-.05-6.01-.12l-.04 1c1.93.07 3.96.12 6.04.12l1.97.01v-.5l-.02-.5h-1.95M277.88 477.83c2.51.44 5.2.8 7.97 1.07l.1-1c-2.76-.27-5.41-.62-7.9-1.06l-.17.99M309.85 478.51l.02 1c3.01-.05 5.63-.16 8.01-.33l-.07-1c-2.36.17-4.96.28-7.96.33M365.27 442.12a62.34 62.34 0 01-3.38 7.17l.87.48a63.03 63.03 0 003.44-7.28l-.93-.37M356.47 405.8c-1.75 0-3.56.4-5.4 1.2l.41.93c1.7-.76 3.38-1.14 4.99-1.14h.01c.84 0 1.67.11 2.46.33l.26-.97c-.87-.23-1.79-.36-2.72-.36h-.01M355.8 458.58l.1-.18a38.91 38.91 0 01-6.6-4.3l-.64.78a39.7 39.7 0 006.64 4.34 63.17 63.17 0 01-2.52 3.03l.75.67a65.52 65.52 0 004.97-6.33l-.82-.57c-.6.86-1.24 1.72-1.88 2.56M343.87 448.45a30.56 30.56 0 01-3.8-6.84l-.94.37a31.51 31.51 0 003.93 7.07l.8-.6M340.6 472.2l.48.88c2.31-1.27 4.55-2.8 6.67-4.55l-.64-.77a42.77 42.77 0 01-6.51 4.45M491.2 229.51a86.59 86.59 0 00-6.48-4.76l-.55.84a85.4 85.4 0 016.4 4.7l.63-.78M502.4 241.03a58.8 58.8 0 00-5.24-6.11l-.72.7a57.73 57.73 0 015.16 6l.8-.6M250.16 463.3l-.75.65a33.02 33.02 0 006 5.41l.58-.82a31.93 31.93 0 01-5.83-5.25M506.2 286.5l.92.38a60.27 60.27 0 002.6-7.63l-.97-.25a59.16 59.16 0 01-2.55 7.5M509.67 255.34a43.38 43.38 0 00-3-7.48l-.9.45a42.38 42.38 0 012.94 7.31l.96-.28M516.67 335.9c-.23-2.77-.55-5.45-.97-7.98l-.99.17c.41 2.5.74 5.15.97 7.9l1-.1M513.04 320.32l.97-.26a64.88 64.88 0 00-2.58-7.63l-.93.38a63.46 63.46 0 012.54 7.51M511.15 271.32a44.46 44.46 0 00.03-8.07l-1 .1a41.55 41.55 0 01-.03 7.87l1 .1M340.66 418.83a26.51 26.51 0 014.53-6.38l-.72-.7a27.5 27.5 0 00-4.7 6.63l.9.45M448.23 208.38c-1.36-.4-2.75-.8-4.15-1.17v.1c-.01.3-.04.61-.07.92 1.33.36 2.64.73 3.94 1.1l.28-.95M242.44 449.5a34.12 34.12 0 002.55 7.67l.9-.43a33.11 33.11 0 01-2.47-7.44l-.98.2M378.53 465.95c2.5.34 5.2.62 7.99.83l.07-1c-2.77-.2-5.44-.48-7.92-.82l-.14 1M365.65 411.16l-.84.55c1.24 1.9 2.21 4.33 2.88 7.22l.98-.22c-.7-3.01-1.72-5.55-3.02-7.55M369.53 426.75l-1-.01a39.02 39.02 0 01-.93 7.82l.98.22c.6-2.73.92-5.43.95-8.03M458.72 326.1l.34.94c2.35-.85 4.84-1.9 7.42-3.12l-.43-.9a82.78 82.78 0 01-7.33 3.08M470.9 449.93l.6.8a69.9 69.9 0 006.12-5.22l-.7-.72a68.87 68.87 0 01-6.02 5.14M503.63 294.13l-.87-.48c-.7 1.29-1.48 2.6-2.29 3.92-.48.79-1.16 1.68-2.02 2.66l.75.66a21.5 21.5 0 002.12-2.8c.82-1.32 1.6-2.66 2.31-3.96M490.62 288.58l-.39.92c1.57.67 3.01 1.48 4.28 2.42.78.58 1.55 1.2 2.29 1.81l.64-.76a50.69 50.69 0 00-2.33-1.85 21.87 21.87 0 00-4.49-2.54M492.75 305.74a107.3 107.3 0 01-6.25 4.95l.59.8a107.8 107.8 0 006.3-4.99l-.64-.76M482.36 439l.76.65a86.43 86.43 0 004.89-6.37l-.82-.58a84.43 84.43 0 01-4.83 6.3M394.56 466.18l-.03 1c2.21.07 4.5.1 6.98.1h1.03v-1h-1.03c-2.47 0-4.75-.03-6.95-.1M491.62 426.06l.83.55c1.48-2.23 2.95-4.46 4.38-6.7l-.83-.53c-1.44 2.23-2.9 4.45-4.38 6.68M515.02 367.83l1 .09c.25-2.94.45-5.56.6-7.98l-.99-.07c-.15 2.42-.36 5.03-.61 7.96M517.07 343.92l-1 .01a150.86 150.86 0 01-.05 7.97l1 .03a177 177 0 00.05-8.01M512.94 383.6l.98.22c.61-2.64 1.06-5.3 1.35-7.93l-1-.11a65.08 65.08 0 01-1.33 7.81M500.23 412.61l.85.52c1.5-2.48 2.8-4.75 4-6.96l-.89-.47c-1.18 2.2-2.48 4.45-3.96 6.91M503.15 298.66l-.76.64a48.22 48.22 0 014.59 6.44l.86-.52a49.48 49.48 0 00-4.69-6.56M507.74 398.57l.91.42a90.12 90.12 0 003.01-7.45l-.94-.33a89.64 89.64 0 01-2.98 7.36M473.11 319.34l.5.87c2.28-1.28 4.59-2.68 6.87-4.16l-.55-.84a132.65 132.65 0 01-6.82 4.13M474.71 286.26l.06 1c2.79-.17 5.44-.08 7.88.24l.14-.99a42.87 42.87 0 00-8.08-.25M443.32 328.57l-.15.99c.88.14 1.83.2 2.84.21 1.6 0 3.38-.18 5.28-.54l-.19-.98c-2.96.56-5.6.67-7.78.32M442.16 462.85l.23.97a91.82 91.82 0 007.74-2.12l-.3-.95c-2.43.78-5.01 1.49-7.67 2.1M434.82 309.77l.93.35c.87-2.3 2.21-4.55 3.98-6.7l-.78-.63a25.12 25.12 0 00-4.13 6.98M426.44 465.31l.1 1c2.77-.27 5.45-.6 7.96-1l-.15-.98c-2.5.38-5.15.71-7.9.98M410.52 466.2l.03 1c2.85-.06 5.46-.16 8-.3l-.06-1c-2.52.14-5.13.24-7.97.3M434.55 317.74l-1 .06.05.68c.27 2.9 1.1 5.3 2.45 7.1l.8-.6c-1.25-1.65-2-3.87-2.25-6.6l-.05-.64M458.97 289.58l.34.94c2.49-.9 5.05-1.64 7.62-2.18l-.2-.98c-2.62.56-5.23 1.3-7.76 2.22M477.87 220.57c-2.27-1.27-4.67-2.51-7.14-3.69l-.43.9c2.45 1.17 4.83 2.4 7.08 3.66l.49-.87M463.38 213.66a157.1 157.1 0 00-7.51-2.83l-.33.95c2.55.88 5.06 1.82 7.46 2.8l.38-.93M444.8 297.2l.6.78c2.02-1.54 4.25-2.98 6.67-4.26l-.47-.88a48.34 48.34 0 00-6.8 4.35M457.24 457.93l.4.92a70.69 70.69 0 007.17-3.66l-.5-.86a69.41 69.41 0 01-7.07 3.6",
    fill: "#21837F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.14 451.28c-.02-2.6.17-5.2.55-7.74 1.06-7.07 5.3-14.34 10.66-19.72a246.54 246.54 0 00-12.93-34.52 256.19 256.19 0 00-29.63-45.72c-1.93-2.14-3.9-4.23-5.92-6.28-7.42-.73-14.66-4.38-20.45-8.86l-23.84 7.77s-18.5-13.47-35.8-66.62c-17.3-53.14-13.63-85.23-13.63-85.23l13.28-4.32a39.18 39.18 0 016.79-11 35.38 35.38 0 0112.62-9c1.98-11.04 4.43-22.03 5.67-33.25.07-10.34-1.4-20.74-2.45-31a449.43 449.43 0 00-4.36-32.58c-.56-2.55-1.2-5.08-1.86-7.6a50.37 50.37 0 01-8.38-5.56 32.27 32.27 0 01-8.83-11.8c-14.73-3.8-27.87-.56-37.57 6.33-14.42 10.25-31.27 21.15-35.33 38.37-6.99 29.62-24.27 87 2 192.95 26.29 105.95 96.03 158.23 119.12 178.06 13.42 11.53 33.04 10.22 50.73 10.01a42.88 42.88 0 0017.2-3.84 39.28 39.28 0 012.36-8.85",
    fill: "#13374D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.27 345.35c21.75 35.41 34 75.71 46.58 115.16 11.02-4.67 21.21-14.36 27.69-30.48-2.63-49.68-65.64-106.95-65.64-106.95l-20.3 6.6c4.33 4.76 8.2 10.02 11.67 15.67M179.78 79.87c3.15 27.67 3.37 50.35-2.12 77.81a106.8 106.8 0 01-7.31 22.71l28.12-9.15s17.22-83.4-9.9-125.1a64.35 64.35 0 00-17-7.62 268.07 268.07 0 018.2 41.35",
    fill: "#5BBDB7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.62 358.63a4.99 4.99 0 00-.21 3.56l.65 4.62.8.53 2.94 1.22c-.31-.9 0-1.85 0-1.85l1.3-4.77s2.02-8.06-3.46-7.72c.03-6.57-1.8-5.48-1.8-5.48l-.22 9.9",
    fill: "#F0AB85"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200 374.6s3.83 14.6 7.1 14.86c3.26.26 6.65-23.13 6.65-23.13l4.44.53s1.72 33.64-8.23 34.25c-9.95.62-11.27-6.82-11.27-6.82l1.32-19.7",
    fill: "#FAD473"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.6 414.52h-26.05v-39.55c7.44-11.35 16.71-8.26 16.71-8.26s8.43.15 9.75 7.89c0 5.6-.42 39.92-.42 39.92",
    fill: "#EE9E35"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.22 361.46l-.39 5.59.19.18a4.85 4.85 0 006.58.09l.1-4.2-6.48-1.66",
    fill: "#EC967C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.18 349.78l.47 9.24c.91-.04 1.45.95 1.28 1.81.1.22.15.45.15.69a10.6 10.6 0 008.24 1.91c5.85-1.12 2.32-12.42 2.32-12.42l-12.46-1.23",
    fill: "#F0AB85"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.24 356.72c-.05-.68-.97-2.11-1.49-2.56-3.3-2.86-.34-4.95.7-5.63 1.17-.74.94-2.85 2.44-4.03 2.3-1.8 4.52.07 5.99-.2 1.47-.28 2.38-2.24 4.52-1.2 2.14 1.04 1.9 2.72 2.59 3.43.69.7 1.94-1.25 4.03.98 3.17 3.4-3.05 4.86-3.05 4.86s-3.4 1.41-7.92-.36c-.62-.24-1.35-.1-1.74.43-1.08 1.47-1.1 9.18-1.1 9.18l-1.5-1.25s-3.28-.55-3.47-3.65",
    fill: "#FACB57"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.74 357.48a1.42 1.42 0 102.63-1.08 1.42 1.42 0 00-2.63 1.08",
    fill: "#F0AB85"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.69 489.08s1.47 2.03 8.38 3.8c1.53.38 3.17.65 3.17 3.16h-6.83l-6.98-1.2v1.2h-3.77s-1.05-6.17 1.15-6.96h4.88",
    fill: "#1B2441"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.05 484.65l-.36 4.43a4.26 4.26 0 01-4.62.16l-.26-.16v-4.43h5.24",
    fill: "#F0AB85"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.3 489.08s1.46 2.03 8.38 3.8c1.52.38 3.16.65 3.16 3.16h-6.83l-6.98-1.2v1.2h-3.77s-1.05-6.17 1.15-6.96h4.88",
    fill: "#1B2441"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.65 484.65l-.36 4.43a4.26 4.26 0 01-4.62.16l-.26-.16v-4.43h5.24",
    fill: "#F0AB85"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.57 374.97s-7.8 18.01 2.15 27.21c9.96 9.2 23.48 7.64 23.48 7.64v-5.19s-12.22-1.03-16.13-9.2c-3.92-8.17 1.56-15.24 1.56-15.24",
    fill: "#EE9E35"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.4 409.1l6.23.14c2.54-.14 4.22-3.92 4.64-6.73a.57.57 0 00-.76-.62c-2.11.74-7.55 2.66-8.96 3.54l-1.15 3.68",
    fill: "#F0AB85"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.6 414.52c7.76 21.92-4.38 70.47-4.38 70.47h-6.92s3.26-68.84-5.74-70.47h17.03",
    fill: "#005C5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.68 389.98c.08 1.7.47 3.55 1.38 5.45 3.92 8.17 16.78 9.25 16.78 9.25v5.24s-14.16 1.46-24.12-7.74c-3.6-3.33-4.88-7.82-5.03-12.2h10.99",
    fill: "#FAD473"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.74 390.77l-.82-.37c-.47-6.04 3.06-10.59 3.1-10.64l.62.48c-.05.06-3.56 4.6-2.9 10.53",
    fill: "#E98333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.82 359.32s-1.44-.43-1.66-3.05c-.23-2.62-1.47-1.8-1.47-1.8s.65 10.33 2.3 10.71c1.64.4.83-5.86.83-5.86",
    fill: "#F0AB85"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.93 414.52c2.12 26.88-15.05 70.47-15.05 70.47h-8.22s5.59-27.87 5.7-54.03c.02-5.66-.2-11.24-.8-16.44h18.37M345.14 248.07a37.85 37.85 0 1123.64-71.92 37.85 37.85 0 01-23.64 71.92zm113.7-21.36c-.75-2.14-8.22-6.54-17.36-9.72a84.18 84.18 0 00-2.17-24.5c7.7-3.51 15.45-8.03 16.09-12.17 1.3-8.4-11.5-27.65-14.76-29.2-2.08-1-10.75 1.28-19.63 5.64a84.13 84.13 0 00-18.4-15.96c2.97-7.95 5.28-16.66 2.8-20.05-5.02-6.86-27.7-11.42-31.1-10.22-2.12.76-6.5 8.19-9.68 17.28a84.08 84.08 0 00-24.9 1.43c-3.46-7.42-7.8-14.64-11.8-15.26-8.4-1.3-27.65 11.5-29.2 14.76-.93 1.93.97 9.56 4.75 17.77a84.18 84.18 0 00-17.46 19.4c-7.24-2.52-14.6-4.17-17.66-1.94-6.86 5.02-11.42 27.7-10.21 31.1.67 1.9 6.74 5.64 14.58 8.69a84.1 84.1 0 001.67 27.08c-6.48 3.23-12.26 7.06-12.81 10.6-1.3 8.4 11.5 27.66 14.76 29.21 1.79.86 8.45-.7 15.93-3.93a84.17 84.17 0 0020.84 17.8c-2.29 6.85-3.65 13.6-1.54 16.5 5.02 6.86 27.7 11.42 31.1 10.21 1.91-.68 5.66-6.78 8.7-14.63 9.08.6 18.05-.3 26.63-2.51 3.32 6.84 7.34 13.12 11.05 13.7 8.4 1.3 27.65-11.5 29.2-14.76.93-1.94-.99-9.64-4.8-17.9a84.05 84.05 0 0016.23-19.72c7.63 2.77 15.7 4.75 18.94 2.39 6.86-5.02 11.42-27.7 10.22-31.1z",
    fill: "#21837F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.08 160.96a53.16 53.16 0 00-67.02 33.87 53.16 53.16 0 0033.87 67.03 53.16 53.16 0 0067.02-33.87 53.16 53.16 0 00-33.87-67.03zm-33.4 101.63a53.93 53.93 0 01-34.35-68 53.93 53.93 0 0168-34.36 53.93 53.93 0 0134.35 68 53.93 53.93 0 01-68 34.36z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435 220.47c-.33-.15-.65-.3-.97-.47a77.13 77.13 0 01-3.47 16.47c-13.29 40.46-57.02 62.56-97.48 49.27a77.26 77.26 0 01-51.07-55.8H282l-1.06-.15a78.27 78.27 0 0051.83 56.9c40.98 13.47 85.28-8.92 98.75-49.9a78.17 78.17 0 003.48-16.32M331.4 139.62a76.83 76.83 0 0149.9-.63c.34.1.65.24.98.35v-1.07l-.66-.23a77.82 77.82 0 00-50.37.57c.06.33.1.67.14 1.01",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.43 491.25s-1.11 1.54-6.33 2.86c-1.15.3-2.39.5-2.39 2.4h5.16l5.26-.92v.91h2.85s.79-4.65-.88-5.25h-3.67",
    fill: "#1B2441"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.15 487.91l.28 3.34c1.03.72 2.4.77 3.48.12l.2-.12v-3.34h-3.96",
    fill: "#AD6044"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.84 491.92s-1.1 1.53-6.32 2.86c-1.15.3-2.4.5-2.4 2.39h5.16l5.26-.91v.9h2.85s.79-4.64-.87-5.24h-3.68",
    fill: "#1B2441"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.57 488.58l.27 3.34c1.04.72 2.4.76 3.48.12l.2-.12v-3.34h-3.95",
    fill: "#AD6044"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.06 405.81l1.28 83.92h6.11s9.3-67.75 7.32-83.92c-1.99-16.16-14.71 0-14.71 0",
    fill: "#1B2441"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.52 405.8s2.13 25.77 7.02 40.04c4.88 14.27 13.71 43.89 13.71 43.89h6.33s-10.57-61.89-8.15-83.93h-18.91",
    fill: "#17324A"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(288 363)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "m",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#k"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M20.01.09s-7.54 17.57-9.45 17.57c-1.53 0 .58-14.35.58-14.35H4.83S-3.11 27.9 3.2 32.39c6.31 4.5 20.17-12.71 20.17-12.71L20.01.08",
    fill: "url(#l)",
    mask: "url(#m)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M330.48 408.03l-2.29 5.64c-1.1 2.22-5.14 2.28-7.82 1.57a.56.56 0 01-.26-.91c1.47-1.62 5.3-5.76 6.62-6.69l3.75.39",
    fill: "#AD6044"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(307 359)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "p",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#n"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M4.37.46S.44 3.13.44 6.19v40.6H23.5V8.84S23.02.38 14.77.38 4.37.46 4.37.46",
    fill: "url(#o)",
    mask: "url(#p)"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#83C8B8",
    d: "M307.82 405.81v-36.47l-.76.03v36.44h.76"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.73 350.39v9.58s-1.59 2.18-4.47 2.18c-2.87 0-2.87-2.07-2.87-2.07v-6.14l4.25-1.1 3.1-2.45",
    fill: "#AD6044"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.02 355.76c-.89-.03-1.7-.17-2.14-.56-2.55-4.07.36-15.04.36-15.04l9.27 1.66.3 7.36a6.17 6.17 0 01-2.32 5.07 9.9 9.9 0 01-5.47 1.51",
    fill: "#AD6044"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.15 342.01s-3.08.58-6.32 0c-3.23-.57-1.16-4.14-1.16-4.14s2.4 1.1 6.65.47c2.87-.43 3.65-.99 5.49 0 2.5 1.33 1.9 5.86 1.9 5.86l-1.38 9.57h-.52s-.13-5.7-.13-7.63c-.54-.88-1.13-.88-1.58-.66-.49.23-.77.77-.77 1.31v9.94s-6.32 2.73-7.94 2.23c-1.6-.49-.53-7.85-.53-7.85s1.86-.81 3.3.8c1.42 1.6 3.15-.06 3.15-.06l-.16-9.84",
    fill: "#1B2441"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.04 366.3l.22-1.2c.5-2.69 3.06-6.03 5.64-6.9h2.68l-.83 5.72-3.78 2.39h-3.93",
    fill: "#F0AB85"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.9 345.23c-.7-.06-1.39.62-1.52 1.52-.13.9.34 1.67 1.05 1.73.71.06 1.4-.62 1.53-1.52.13-.9-.34-1.67-1.05-1.73",
    fill: "#AD6044"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.64 363.29l-5.21 3.02s3.27-.04 3.32 0l5.53-4.62s-.4-.81-1.65-.13a6.34 6.34 0 00-1.99 1.73",
    fill: "#F0AB85"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(320 361)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "s",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#q"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M8.04.93S21.08 15.4 21.08 24.09 10.5 48.06 10.5 48.06l-5.23-1.53S9.99 27.6 9.99 22.57c0-5.04-9.7-12.42-9.7-12.42",
    fill: "url(#r)",
    mask: "url(#s)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M329.6 383.57c0 4.33-3.83 20.19-4.74 23.88l.78.2c1.1-4.57 4.73-19.82 4.73-24.08 0-5.17-9.44-12.42-9.84-12.72l-.46.6c.1.08 9.53 7.33 9.53 12.12",
    fill: "#83C8B8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.14 353.8s1.07 5.62-2.4 10.12a1.5 1.5 0 01-.97.54c-.8.11-1.36-.17-1.8-.3-.64-.18-.95-.5-1.1-.78-.12-.23-.08-.5.08-.75.7-1.05 2.88-4.64 1.89-7.83 1.85-1.5 4.3-1 4.3-1",
    fill: "#EC944F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.49 363.97c-.4-.2-.48-.33-.61-.59-.13-.23-.09-.5.07-.75.7-1.05 2.88-4.64 1.89-7.83.65-.53 1.38-.8 2.05-.94.11 3.5-.64 5.83-3.4 10.11",
    fill: "#F2AE53"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.04 358.44c-.16.8-.55 1.4-.87 1.33-.31-.06-.44-.77-.27-1.57.16-.8.55-1.4.87-1.34.31.07.44.77.27 1.57",
    fill: "#EC944F"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EC944F",
    d: "M300.83 356.89l-.33-.08.02.17.23.08.08-.17"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DC3F5E",
    d: "M300.25 359.77l-.4-.07.45-.07-.05.14"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.77 358.38c-.16.8-.55 1.4-.87 1.34-.31-.07-.44-.77-.27-1.58.17-.8.56-1.4.87-1.33.32.06.44.77.27 1.57M305.54 349.08h.62a2.1 2.1 0 012.15 2.05v1.62a2.1 2.1 0 01-2.15 2.05h-.62v-5.72",
    fill: "#FACB57"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.65 350.7c0 4.43 1.02 8.02 2.28 8.02 1.26 0 2.28-3.6 2.28-8.03 0-4.44-1.02-8.03-2.28-8.03-1.26 0-2.28 3.6-2.28 8.03",
    fill: "#1B2441"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFE",
    d: "M291.3 347.73l-1.8 1.17v2.6l1.86 1.68.65-3.38-.7-2.07"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.2 350.7c0-3.74-.71-6.86-1.69-7.77 7.55 5.44 16.4 6.2 16.4 6.2v5.68s-11.97-.68-16.4 3.64c.98-.9 1.7-4.03 1.7-7.76",
    fill: "#EE9E35"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.26 350.2c0 .72.11 1.3.25 1.3.13 0 .25-.58.25-1.3 0-.72-.12-1.3-.25-1.3-.14 0-.25.58-.25 1.3",
    fill: "#FACB57"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.94 362.15c.18.07.83.48 2.91.48 1.52 0 2.2-1.87 2.46-2.88.1-.36.17-.87-.27-1.1l-2.44-.33-2.66 3.83",
    fill: "#F0AB85"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#13374D",
    d: "M449.09 498.32l-78.83-245.08h4.48l78.84 245.08h-4.5M408.32 498.32L329.5 253.24h4.5l78.82 245.08h-4.49"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#13374D",
    d: "M395.17 316.89v3.65l-42.24-.02-.72-3.66 42.96.03M386.44 293.14v3.66l-42.24-.03-.72-3.65 42.95.02M379.21 269.4v3.65l-42.23-.02-.72-3.66 42.95.02M402.86 340.94v3.65l-42.24-.02-.72-3.65 42.96.02M410.08 364.99v3.65l-42.24-.02-.72-3.66 42.96.03M417.55 389.98l1.7 3.65-42.23-.02-.72-3.66 41.25.03M425.47 414.96l1.7 3.66-42.23-.02-.72-3.66 41.25.02M432.88 439.4l1.71 3.65-42.24-.02-.72-3.66 41.25.03M439.03 464.36l1.7 3.65-42.23-.02-.72-3.65 41.25.02"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M460.93 470.25l3 7.91c.24 1.1.28 2.43-.86 3.09 0 0-.76.44-1.57.72-.54-.12-4-10.8-4-10.8l.04-.07c1.37-1.78 3.4-.85 3.4-.85",
    fill: "#21837F"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1B2441",
    d: "M461.5 481.97l-4-10.8-.52.3 4.03 10.7.5-.2"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFE",
    d: "M462.12 473.38l.26.71-1.38.27-.26-.7 1.38-.28M462.7 474.9l.26.72-1.38.27-.26-.7 1.38-.28"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M464.25 468.38l-3.32 1.87c-.19.8.1 1.63.73 2.15l.12.1 3.66-.95-1.2-3.17",
    fill: "#F0AB85"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M490.72 418.46s-3.29 3.54-4.13 9.77c-.57 4.15.99 10.72 1.16 15.88.15 4.72-1.98 8.47-5.72 11.35l-17.78 12.92 1.19 3.17s24.34-3.65 30.73-14.56c6.4-10.9 7.91-35.58 7.91-35.58l-13.36-2.95",
    fill: "#1B2441"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M476.56 405.02l-9.15 20.43s-3.76.44-5.39 1.88c-.85.75-.81 2.26-.58 3.53a1.26 1.26 0 002.07.72c1-.87 2.3-1.85 3.15-2 2.26-.37 2.93-1.97 2.93-1.97l13.13-20.58-6.16-2M522.7 363.94l4.68-4-3.63-19.81-5.64-2.88s.61-1.1 2-.63c1.4.46 2.57.19 2.57.19s1.06-1.3-.94-2.19c-1.13-.76-1.88 0-5.14-.13 0-.5 4.3-1.7 4.3-1.7 1.33-.42 4.75 2.22 4.75 2.22.23.32.38.69.44 1.07l.54 3.67s7.27 19.93 7.27 22.06c0 2.13-4.08 5.04-4.08 5.04l-7.13-2.91",
    fill: "#F0AB85"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M497.49 420.51s-2.82 3.4-1.13 11.3c1.08 5.04 5.82 11.38 9.01 15.75 2.28 3.13 2.33 7.07 1.65 10.88-2.61 14.5 1.56 32.2 1.56 32.2h3.38s5.08-25.94 6.58-44.17c1.36-16.44-5.67-28.55-5.82-28.76l-15.23 2.8",
    fill: "#13374D"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EE9E35",
    d: "M516.25 336.54l10.62 1.55.41-2.8-10.62-1.56-.41 2.8"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFE",
    d: "M527.9 335.38l-.41 2.8-.97-.14.4-2.8.98.14"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M527.28 338.15c.78.11 1.44.06 1.62-1.2.2-1.4-.42-1.52-1.2-1.64l-.42 2.84",
    fill: "#1B2441"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFE",
    d: "M516.25 336.54l-2.07-1.25.15-1.02 2.33-.54-.41 2.8"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#13374D",
    d: "M514.18 335.3l-.9-.65 1.05-.38-.15 1.03"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E98333",
    d: "M526.67 336.97l-.1.64-10.26-1.5.1-.65 10.26 1.51M526.87 335.62l-.1.64-10.26-1.51.1-.64 10.26 1.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M489.19 380.43c-6.05 4.44-13.17 25.8-13.17 25.8l5.31 2.97 8.64-11.85s.84 13.72-1.23 24.25c.94 3.94 5.43 3.5 12.7 2.12s12.03-4.51 12.03-4.51.31-19.04 1.25-29.14c.94-10.1-.91-11.17 1.63-10.84 5.68-3.22 14.99-13.61 14.99-13.61l-8.65-1.68-18.6 10.9s-9.11 2.4-14.9 5.59",
    fill: "#5BBDB7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M499.73 355.18l4.5 4.43a7.79 7.79 0 012.12 7.23l-.53 2.37-6.09-14.03",
    fill: "#F0AB85"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M494.3 353.5c-10.9 0-6.27 20.93-6.27 20.93s1.94 13.57 6.26 19.03c3.75 4.72 11.15 3.3 14.66 1.03a13.4 13.4 0 015.66-2.09c2.97-.36 6.5-1.67 6.5-7.03 0-5.04-6.02-8.94-9.98-11.73a13.07 13.07 0 01-5.14-7.6c-1.27-5.16-4.36-12.54-11.7-12.54",
    fill: "#EE9E35"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M509.16 494.4h8.46c1.12.15 2.38.58 2.59 1.88 0 0 .14.86.12 1.72-.3.46-11.52-.07-11.52-.07l-.04-.05c-1.2-1.9.4-3.47.4-3.47",
    fill: "#21837F"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#13374D",
    d: "M520.33 498l-11.52-.07.1.6h11.44l-.02-.53"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFE",
    d: "M512.51 494.4h.76l-.24 1.38h-.73l.21-1.39M514.14 494.4h.76l-.23 1.38h-.74l.21-1.39"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M508.58 490.65l.58 3.76c.68.45 1.56.48 2.27.07l.13-.08.4-3.75h-3.38M520.11 336.62c-1.39-.46-2 .63-2 .63l3.75 1.92.15-.07c.62-.25 1.9-.8 2.49-.9-.36-.37-3.7-1.35-4.39-1.58",
    fill: "#F0AB85"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EC967C",
    d: "M259.78 171.39l-9.91 25.9-6.25-4.64 13.96-23.54 2.2 2.28"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.55 163.56a4.03 4.03 0 00-.9 2.73l-.43 3.74.5.58 1.76 1.56c-.06-.78-.15 0-.15 0l2.82-4.91s3.41-2.19-.89-5.41c-.41-.31-.99-.38-1.41-.1a3.16 3.16 0 00-1.3 1.8",
    fill: "#EC967C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.9 216a162.83 162.83 0 0011.97-18.7l-5.38-6.13-6.6 7.69V216",
    fill: "#005C5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.41 328.28l3.16.55c.65-3.92 10.47-22.48 11.27-32.12.88-10.7 3.37-22.62 3.37-22.62l-10.56-3.14s-2.67 0 .26 21.81c-6.6 8.67-8.37 28.34-7.5 35.52",
    fill: "#EC967C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.19 263.01s2.48 14.93 5.93 30.89c-3.6 9.63 1.88 36.53 1.99 36.43.41-.39 2.3 1.95 2.3 1.95s4.01-23.73 4.9-34.44c.88-10.7 1.1-23.75 1.1-23.75l-16.22-11.07",
    fill: "#F0AB85"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.66 328.83s-1.5 1.27-1.23 2.9c.28 1.62.67 5.43.67 5.43h1.54l-.05-3.55c0-.23 3.32 3.55 3.88 3.55h8.18s.54-2.4-4.26-3.17-8.73-5.16-8.73-5.16",
    fill: "#13374D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.93 326.12l-.22 3.39c-.05.71.15 1.42.56 2 .45.65 1.2 1.54 2.46 2.56-2.37.76-4.53-1.9-5.66-3.67a4.21 4.21 0 01-.61-2.9l.4-2.66 3.07 1.28",
    fill: "#EC967C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.41 327.99s-2.09.18-2.43 1.77c-.35 1.59-1.33 4.8-1.33 4.8l1.13.9 1.6-3.18s3.46 4.65 4 4.88h8.93s0-2.96-5.58-3.1c-5.15-.12-6.32-6.07-6.32-6.07",
    fill: "#1B2441"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F0AB85",
    d: "M270.2 170.14l-9.92 25.9-6.25-4.65L268 167.86l2.2 2.28"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.96 162.3a4.04 4.04 0 00-.9 2.74l-.43 3.74.51.58 1.76 1.56c-.07-.78-.15 0-.15 0l2.82-4.91s3.4-2.19-.9-5.42c-.4-.3-.98-.37-1.4-.09-1.08.72-1.3 1.8-1.3 1.8",
    fill: "#F0AB85"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EC967C",
    d: "M240.2 202.4h-6.38l2.55-7.52 5 3.07-1.16 4.44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.7 210.47l-.12-.52c6.33-8.16 11.7-13.9 11.7-13.9l-5.38-6.13-12.22 11.6-3.59.02s-4.84-3.2-9.07 1.17c-1.55 1.6-2.58 5.92-1.54 10.49 2.84 12.6.62 19.26.62 19.26l16.48 6.14.63-18.63v-.03c.05-1.5.55-2.93 1.34-4.2a7.52 7.52 0 001.15-5.27",
    fill: "#5BBDB7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.45 181.39l-10.47 3.67 1.03 7.82c.02.1.05.21.06.32l.6.13.1.02.1.02c2.42.6 4.13 2.6 4.9 4.9 1.49.25 3.03.26 4.53-.05 1.03-.21 1.96-.54 2.38-1.03 2.22-4.82-3.23-15.8-3.23-15.8",
    fill: "#F0AB85"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.21 188.04c-2.82 1.38-2.15 15.92-2.64 25.82a11.25 11.25 0 01-9.53 10.52c-3.73.6-7.83.7-10.3-.7 1.63-1.34 10.45-14.3 7.62-31.48-.37-2.26-.41-8.55 3.4-11.97 4.22-3.8 12.94 1.16 12.94 1.16s2.39 4.76-1.49 6.65",
    fill: "#1B2441"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.92 232.08s2.19 11.17 2.19 17.81c0 3.65-.9 26.65-.9 26.65s-15.66 1.13-18.7 1.13c-.75-18.84-5.05-19.42-5.05-28.21 0-3.82 1.96-8.14 3.47-10.9a15.93 15.93 0 002.17-6.1l.1-.36 16.72-.02",
    fill: "#FACB57"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.93 366.28s-10.28 19.8-9.56 24.16c.72 4.36 9.56 11.92 9.56 11.92l1.43-2.47-4.49-10.14 5.78-16.65-2.72-6.82M29.96 357.78l-.84 5.67h-5.04l-.51-8.7 6.39 3.03",
    fill: "#D29577"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.18 382.82v-15.98c-6.47-4.58-11.04-4.1-11.04-4.1-1.13-.11-1.37-.11-2.88-.11-.04 0-10.83-.8-8.84 16.28 4.3 14.53 2.23 20.94 2.23 20.94s11.28 4.6 17.57 1.35c-1.58-3.63 1.33-13.6 2.92-18.45l.04.07",
    fill: "#005C5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.37 360.94s-4.28 2.51-4.28 6.49c0 2.46.97 3.92 2.08 5.64a8.16 8.16 0 01-.3 9.41c-.77 1-.92 2.01-.71 2.99.79 3.77 5.98 4.33 7.99 1.04.74-1.2 1.45-2.65 1.97-4.31.88-2.8.02-4.55-1.06-5.6-.91-.88-1.02-2.33-.13-3.24 1.62-1.66 3.21-4.16 1.2-6.36-3.4-3.69-4.36-7.15-4.36-7.15l-2.4 1.09",
    fill: "#1B2441"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.82 488.55l3.02.52c.63-3.74 10.02-21.5 10.78-30.72a208.13 208.13 0 013.23-21.63l-10.1-3s-2.56 0 .25 20.86c-6.32 8.29-8 27.1-7.18 33.97M34.6 344.4l-9.32-.44-1.66 6.42-.05.27.43.29.07.05.06.05c1.7 1.22 2.4 3.32 2.28 5.36 1.08.66 2.27 1.15 3.55 1.38.86.16 1.69.2 2.17-.05 3.25-3.06 2.46-13.33 2.46-13.33",
    fill: "#D29577"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.34 359.58c2.43.27-1.42 0 2.43.27.1-2.04 6.67-7.35 7.92-8.42 3.2-2.75 2.95-6.07 2.95-6.07s-6.34-6.84-10.45-5.39c-3.22 1.14-4.33 3.68-4.85 5.42-.45 1.53-1.4 4.13 2 14.19",
    fill: "#1B2441"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.26 426.12s2.37 14.28 5.67 29.54c-3.44 9.22 1.8 34.94 1.9 34.85.4-.37 2.22 1.87 2.22 1.87s3.83-22.7 4.67-32.94c.85-10.24 2.15-22.72 2.15-22.72l-16.6-10.6",
    fill: "#D29577"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.4 489.07s-1.43 1.22-1.17 2.78c.27 1.55.64 5.2.64 5.2h1.48l-.05-3.4c0-.22 3.17 3.4 3.7 3.4h7.83s.52-2.3-4.07-3.03c-4.6-.74-8.35-4.94-8.35-4.94",
    fill: "#13374D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.76 360.94h-2.39a.97.97 0 01-.97-.97v-.23c0-.54.44-.97.97-.97h2.4c.52 0 .96.44.96.97v.23c0 .53-.44.97-.97.97",
    fill: "#FAD473"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.78 397.71s2.56 14.41 2.56 21.59c0 3.94-1.82 20.66-1.82 20.66s-14.98.44-18.03.44c-.39-11.86-4.8-19.67-4.8-29.16 0-6.7 5.9-12.53 5.9-12.53l16.19-1",
    fill: "#13374D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.35 381l-.67.2a4.18 4.18 0 00-2.84 2.8l-.16.54s-5.91 2.04-12.5 2.88c-6.73-19.14-9-20.58-9-20.58s-4.34 1.38-4.34 6.62c0 4.4 2.94 16.84 8.52 20.74a5.26 5.26 0 005.27.36c8.97-4.26 15.3-7.9 15.3-7.9l6.78-3.75-3-1.57a4.52 4.52 0 00-3.36-.34M16.19 486.49l-.21 3.24c-.04.68.14 1.35.53 1.91.43.62 1.16 1.47 2.35 2.45-2.26.73-4.32-1.81-5.4-3.5a4.03 4.03 0 01-.6-2.78l.39-2.55 2.94 1.23",
    fill: "#D29577"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.82 488.27s-2 .18-2.32 1.7c-.33 1.51-1.28 4.58-1.28 4.58l1.1.87 1.53-3.04s3.3 4.44 3.82 4.66h8.54s0-2.82-5.35-2.95c-4.92-.12-6.04-5.82-6.04-5.82",
    fill: "#1B2441"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.3 64.9c.68.58 1.7.5 2.3-.17l14.33-16.59a1.62 1.62 0 10-2.46-2.12L211.14 62.6c-.59.68-.51 1.7.17 2.3M216.28 133.14a1.62 1.62 0 012.3-.16l16.58 14.33a1.62 1.62 0 11-2.12 2.45l-16.6-14.33a1.62 1.62 0 01-.16-2.29M219.82 103.5c.07.9.85 1.56 1.74 1.5l21.87-1.6a1.62 1.62 0 10-.24-3.23l-21.87 1.59c-.89.07-1.56.84-1.5 1.74",
    fill: "#83C8B8"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardSupport);
export default __webpack_public_path__ + "static/media/card-support.676719fa61921bc3b94a035481689f7b.svg";
export { ForwardRef as ReactComponent };